import React from 'react';

import { Box, Typography } from '@mui/material';
import AccordionCDS from 'app/shared/componentsRestyled/coreDesignSystem/AccordionCDS';
import PropTypes from 'prop-types';

import { truncatedNameStyles } from '../Alerts.styles';
import { AlertsTestIds } from '../Alerts.testIds';

import {
  checklistItemsListStyles,
  connectorCleanerStyles,
  connectorStyles,
  getAccordionItemCustomStyles,
  getChecklistItemContainerStyles,
  getChecklistItemStyles,
} from './ChecklistItem.styles';
import ChecklistItemInfo from './ChecklistItemInfo';

const ChecklistItem = ({ item, isLast = false, nestedLevel = 0, disabled, statusDisplayType }) => {
  const nestedItemsCount = item.nestedFields?.length || 0;

  if (nestedItemsCount > 0) {
    return (
      <Box
        data-testid={AlertsTestIds.getItemRowId(item.id)}
        sx={getChecklistItemContainerStyles({ nestedLevel })}
      >
        {isLast && <Box sx={connectorCleanerStyles} />}
        <Box sx={connectorStyles} />
        <AccordionCDS
          additionalSummaryContent={
            <ChecklistItemInfo
              disabled={disabled}
              item={item}
              nestedLevel={nestedLevel}
              statusDisplayType={statusDisplayType}
            />
          }
          arrowSize={18}
          customStyles={getAccordionItemCustomStyles({
            isPendingChange: item.isPendingChange,
            isManuallyChanged: item.isManuallyChanged,
          })}
          title={item.name}
        >
          <Box sx={checklistItemsListStyles}>
            {item.nestedFields.map((item, index) => (
              <ChecklistItem
                isChild
                disabled={disabled}
                isLast={nestedItemsCount === index + 1}
                item={item}
                key={item.id}
                nestedLevel={nestedLevel + 1}
                statusDisplayType={statusDisplayType}
              />
            ))}
          </Box>
        </AccordionCDS>
      </Box>
    );
  }

  return (
    <Box
      data-testid={AlertsTestIds.getItemRowId(item.id)}
      sx={getChecklistItemContainerStyles({ nestedLevel, isEmpty: true })}
    >
      {isLast && <Box sx={connectorCleanerStyles} />}
      <Box sx={connectorStyles} />
      <Box
        sx={getChecklistItemStyles({
          isPendingChange: item.isPendingChange,
          isManuallyChanged: item.isManuallyChanged,
        })}
      >
        <Typography sx={truncatedNameStyles} title={item.name} variant="regular14">
          {item.name}
        </Typography>
        <ChecklistItemInfo
          isEmpty
          disabled={disabled}
          item={item}
          nestedLevel={nestedLevel}
          statusDisplayType={statusDisplayType}
        />
      </Box>
    </Box>
  );
};

ChecklistItem.propTypes = {
  item: PropTypes.shape({
    categoryId: PropTypes.string.isRequired,
    checklistId: PropTypes.string.isRequired,
    expressionResult: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    orderSequence: PropTypes.number.isRequired,
    isPendingChange: PropTypes.bool.isRequired,
    isManuallyChanged: PropTypes.bool.isRequired,
    expression: PropTypes.object,
    nestedFields: PropTypes.array,
    calculation: PropTypes.object,
    parentId: PropTypes.string,
    visibilityExpression: PropTypes.object,
    fieldRef: PropTypes.string,
  }).isRequired,
  statusDisplayType: PropTypes.string.isRequired,
  isLast: PropTypes.bool,
  nestedLevel: PropTypes.number,
  disabled: PropTypes.bool,
};

export default ChecklistItem;
